// utils
import { isVideoAsset, isImageAsset } from 'util/file'

// local constants
export const DEFAULT_IMAGE_ASSET_DURATION = 5000

/* HELPERS ********************************************************************/

export const getDuration = (asset) => {
  if (isImageAsset(asset.raw.mimeType))
    return asset.duration || DEFAULT_IMAGE_ASSET_DURATION
  return 0
}



// WEBPACK FOOTER //
// ./src/app/util/asset.js